(ns hypnos.dme.tile.field.consult-mask-selector-type
  "Field for the mask selector type."
  (:require [hypnos.i18n :refer [tr]]))

;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;
;;; field

(defn field
  ([state]
   (field state {:disabled false}))
  ([state {:keys [disabled] :or {disabled false}}]
   [:div.field.is-horizontal
    [:div.field-label.is-normal]
    [:div.field-body
     [:div.field
      [:label.switch.is-rounded
       [:input
        {:type      :checkbox
         :disabled  disabled
         :checked   (= :selector-type/prescriber (get-in @state [:recommendations :custom :selector-type :value]))
         :on-change (fn [e]
                      (let [old-value (get-in @state [:recommendations :custom :selector-type :value])
                            new-value (when (-> e .-target .-checked) :selector-type/prescriber)
                            changed?  (or (get-in @state [:recommendations :custom :selector-type :dirty?])
                                          (not= new-value old-value))]
                        (swap! state assoc-in
                               [:recommendations :custom :selector-type :value]
                               new-value)
                        (swap! state assoc-in
                               [:recommendations :custom :selector-type :dirty?]
                               changed?)))
         :on-focus  (fn [_]
                      (swap! state assoc-in
                             [:recommendations :custom :selector-type :touched?]
                             true))}]
       [:span.check.is-info]
       [:span.control-label (tr :ui.label/prescriber)]]]]]))
